<div class="form-check">
	<input
		class="form-check-input"
		type="radio"
		[id]="label || null"
		[name]="name"
		[disabled]="disabled"
		[readonly]="readonly"
		[checked]="value === optionValue"
		(input)="handleInput($event)"
		(blur)="handleBlur()"
	/>

	@if (label) {
		<label class="form-check-label" [for]="label">
			{{ label }}
			@if (required) {
				<span class="text-danger">*</span>
			}
		</label>
	}

	@if (error) {
		<div class="text-danger mt-1">
			{{ error }}
		</div>
	} @else if (hint) {
		<div class="form-text mt-1">
			{{ hint }}
		</div>
	}
</div>
